import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import qs from "qs";

import { signInSAML } from "./actions";
import Spinner from "~/components/Spinner";

const SAMLLogin = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isSignInSAML, isSAMLAuthenticated } = useSelector(
    (state) => state.loginReducer
  );

  useEffect(() => {
    const query = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    dispatch(signInSAML(query.payload));
  }, []);

  useEffect(() => {
    history.push("/");
  }, [isSAMLAuthenticated]);

  return <Spinner spinning={isSignInSAML} />;
};

export default SAMLLogin;
